import { useSelector } from 'react-redux'
import * as Styled from './styled'
import type { IProps } from './types'
import { getAvatar } from './utils'
import { TRootState } from 'store/types'

const UserAvatar = ({ $isHovered }: IProps) => {
  const { avatar } = useSelector((state: TRootState) => state.user.data)
  return <Styled.UserAvatar $isHovered={$isHovered} $data={getAvatar(avatar)} />
}

export default UserAvatar
